module.exports = __webpack_public_path__ + "static/catalogue2-01d0a3666e1a867c08bee91721962fbe.png";